import { render } from "./wtg.vue?vue&type=template&id=98946edc&scoped=true"
import script from "./wtg.vue?vue&type=script&lang=js"
export * from "./wtg.vue?vue&type=script&lang=js"

import "./wtg.vue?vue&type=style&index=0&id=98946edc&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98946edc"]])

export default __exports__